var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLink = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.851 11.038a2.906 2.906 0 1 0 4.11 4.11l1.768-1.768a.844.844 0 0 1 1.194 1.193l-1.768 1.768a4.594 4.594 0 1 1-6.497-6.496l1.768-1.768A.844.844 0 0 1 6.619 9.27l-1.768 1.768Zm3.227-4.42a.844.844 0 0 1 0-1.193l1.767-1.767a4.594 4.594 0 0 1 6.497 6.496l-1.768 1.768a.844.844 0 1 1-1.193-1.193l1.768-1.768a2.906 2.906 0 0 0-4.11-4.11L9.27 6.619a.844.844 0 0 1-1.193 0Zm-1.236 5.345a.844.844 0 0 0 1.194 1.193l5.176-5.176a.844.844 0 0 0-1.193-1.194l-5.177 5.177Z",
    fill: "currentColor"
  })));
};
export { SvgLink as ReactComponent };